import { ApiUtils, _axios } from "@/api/apiUtil.js";
import constant from "@/util/constant.js";
const api = {
  list: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/edu/subject/listWithCnt",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },  
  selectNameByKid: (
    params,
    successCallback,
    failCallback,
    exceptionCallback
  ) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/edu/subject/selectNameByKid",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  save: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.postLoadingAjax(
      constant.serverUrl + "/edu/subject/save",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/edu/subject/toUpdate",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  move: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/edu/subject/move",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  update: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.putLoadingAjax(
      constant.serverUrl + "/edu/subject/update",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  remove: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.deleteLoadingAjax(
      constant.serverUrl + "/edu/subject/remove",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
};

export default api;
